import Experience from "../Experience.js";
import * as THREE from "three/webgpu";

export default class Bulb {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;

        this.setMesh();
        this.setLight();
    }

    setMesh() {
        this.mesh = this.resources.items.lightbulb.scene;

        // Simple transparent glass (no advanced physical features)
        const glassMaterial = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.18,           // adjust to taste (0.1–0.3)
            roughness: 0.15,         // slight roughness for visible highlights
            metalness: 0.0,
            side: THREE.DoubleSide
        });
        glassMaterial.depthWrite = false;
        glassMaterial.renderOrder = 2;

        // Simple glowing filament (emissive)
        this.filamentMaterial = new THREE.MeshStandardMaterial({
            color: 0x222222,               // dark base
            emissive: new THREE.Color(0xffb060),
            emissiveIntensity: 12.0,       // glow strength
            roughness: 1.0,
            metalness: 0.0
        });

        // Simple helpers for the rest
        const wireMaterial = new THREE.MeshStandardMaterial({
            color: 0x111111,
            roughness: 0.6,
            metalness: 0.1
        });

        const capMaterial = new THREE.MeshStandardMaterial({
            color: 0x777777,
            roughness: 0.3,
            metalness: 1.0
        });

        // Assign materials
        this.filamentMesh = null;
        this.mesh.traverse((child) => {
            if (!child.isMesh) return;

            switch (child.name) {
                case 'Bulb':
                case 'Inner':
                    child.material = glassMaterial;
                    child.renderOrder = 2;
                    break;

                case 'Filament':
                    child.material = this.filamentMaterial;
                    this.filamentMesh = child;
                    break;

                case 'InnerHandles':
                case 'OuterHandles':
                    child.material = wireMaterial;
                    break;

                case 'Bottom':
                    child.material = capMaterial;
                    break;
            }
        });

        // Transform and add once
        this.mesh.position.set(0, 2, 0);
        this.mesh.scale.set(20, 20, 20);
        this.scene.add(this.mesh);
    }

    setLight() {
        // A single point light so the filament glow affects the scene
        this.light = new THREE.PointLight(0xffb060, 10, 6, 2); // color, intensity, distance, decay
        this.light.castShadow = true;

        if (this.filamentMesh) {
            this.filamentMesh.add(this.light);
            this.light.position.set(0, 0, 0); // emit from filament
        } else {
            this.mesh.add(this.light);
            this.light.position.set(0, 0.11, 0);
        }
    }
}